import React, { Fragment } from 'react';

const SpacerDot = () => <>&nbsp;&middot;&nbsp;</>;

export default SpacerDot;
